import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Environment(props) {
    return (
        <SvgIcon {...props}>
            <path fill="#94C906" d="M2.5 15.3s6.9-1.2 8 12.4 8.2 41.8 31.7 35.6c0 0 3.3 2.3-.3 22.4 0 0 3 1 3.4-1.4 0 0 5.5-13.7 7.4-13.6 0 0 6 5.9 12.1 5.6 0 0 8.7-.9 16.4-9.7 0 0 11-13.1 12.5-11.9l3.3.7c.3.7-3.8-7-14.1-10.2s-30.5-6.1-31.8 21c0 0 14.5-19.3 35.8-14 0 0-25.2-6.1-41.5 26.8 0 0 5.5-41.6-26.9-59.6 0 0 24.5 6.9 29 40.2 0 0 10.6-19.8 2.9-31.1 0 .1-12.8-22.3-47.9-13.2z" />
        </SvgIcon>
    );
}

Environment.defaultProps = {
    viewBox: '0 0 100 100'
};

export default Environment;
